import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useHistory } from "react-router";
import { useAuctionFees } from "../../../../services/AuctionService";
import { LoadingComponent } from "../../../loading/LoadingComponent";
import * as Styles from "../../styles/VehicleDetailsListStyles";

interface BidHistory {
  auctionId: string;
}

const AuctionFeesContainer: React.FC<BidHistory> = ({ auctionId }) => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const classes = Styles.VehicleDetailsListStyles();

  const [auctionFee, auctionFeeLoading] = useAuctionFees(auctionId, () => {
    enqueueSnackbar("There was a problem loading the auction fee, please try again.", { variant: "error" });
  });

  // Format as currency: "1,234.00" etc
  const formatCurrency = (value: number) =>
    value.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <Grid container spacing={3}>
      {auctionFeeLoading && (
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <LoadingComponent label="Loading fees" />
        </Grid>
      )}

      {!auctionFeeLoading && (
        <>
          {auctionFee?.bespokeBands && (
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.descriptionTitle}>
                Bespoke Hammer fee
              </Typography>
              <Typography color="primary">
                Bespoke Hammer fees associated with this specific lot
              </Typography>

              <TableContainer component={Paper} style={{ marginTop: 16 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Hammer / selling price range</TableCell>
                      <TableCell>Buyers fee</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {auctionFee?.bespokeBands?.bands?.length ? (
                      auctionFee.bespokeBands.bands.map((band, idx) => (
                        <TableRow key={idx}>
                          <TableCell>
                            {band.max === null || band.max === undefined
                              ? `£${formatCurrency(band.min)} +`
                              : `£${formatCurrency(band.min)} to £${formatCurrency(band.max)}`}
                          </TableCell>
                          <TableCell>
                            {band.isPercentage
                              ? `${(band.fee * 100).toFixed(2)}%`
                              : `£${formatCurrency(band.fee)}`}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={2}>No fee bands available</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          )}

          {auctionFee?.standardBands && auctionFee?.bespokeBands == null && (
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.descriptionTitle}>
                {auctionFee.bespokeBands ? 'Standard' : ''} Hammer fee
              </Typography>
              <Typography color="primary">
                Hammer fees associated with this specific lot
              </Typography>

              <TableContainer component={Paper} style={{ marginTop: 16 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Hammer / selling price range</TableCell>
                      <TableCell>Buyers fee</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {auctionFee.standardBands.bands?.length ? (
                      auctionFee.standardBands.bands.map((band, idx) => (
                        <TableRow key={idx}>
                          <TableCell>
                            {band.max === null || band.max === undefined
                              ? `£${formatCurrency(band.min)} +`
                              : `£${formatCurrency(band.min)} to £${formatCurrency(band.max)}`}
                          </TableCell>
                          <TableCell>
                            {band.isPercentage
                              ? `${(band.fee * 100).toFixed(2)}%`
                              : `£${formatCurrency(band.fee)}`}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={2}>No fee bands available</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};
export default AuctionFeesContainer;
